package com.tixforgigs.common.ui.components.templateConfigurator

import com.tixforgigs.apax.models.ColorVariable
import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.ui.components.grid.gridContainer
import com.tixforgigs.common.ui.components.mandarin.mandarinColorInput
import com.tixforgigs.common.ui.components.mandarin.mandarinHeadline
import io.kvision.core.Container
import io.kvision.html.span
import io.kvision.material.ExperimentalMaterialApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

@OptIn(ExperimentalMaterialApi::class)
fun Container.colorOptions(
  state: MutableStateFlow<List<ColorVariable>>,
) {
  gridContainer().bind(state) { list ->
    gridItem(12) {
      @MissingTaramiMessageKey
      mandarinHeadline(subheadline = "Colors")
    }
    list.forEachIndexed { index, item ->
      gridItem(6) {
        mandarinColorInput(
          listState = state,
          item = item,
          onUpdate = { item ->
            state.update { it.toMutableList().apply { set(index, item) } }
          }
        )
      }
    }
    if (list.isEmpty()) {
      gridItem(12) {
        @MissingTaramiMessageKey
        span { +"aktuell kannst du keine Farben bearbeiten" }
      }
    }
  }
}
